import { AGENCY_FIELDS, VOOH_CAMPAIGN_FIELDS, VOOH_MEDIA_TREE_FIELDS } from '../fragments'
import { gql } from '@apollo/client'

export const GET_VOOH_CAMPAIGN = gql`
  ${VOOH_CAMPAIGN_FIELDS}
  ${AGENCY_FIELDS}
  ${VOOH_MEDIA_TREE_FIELDS}
  query voohCampaign($id: ID!) {
    node(id: $id) {
      ... on VoohCampaign {
        ...VoohCampaignFields
      }
    }
  }
`
export const GET_VOOH_CAMPAIGN_PUBLIC = gql`
  ${VOOH_CAMPAIGN_FIELDS}
  ${AGENCY_FIELDS}
  ${VOOH_MEDIA_TREE_FIELDS}
  query voohCampaignReportPublic($voohCampaignUuid: String!) {
    voohCampaignReportPublic(voohCampaignUuid: $voohCampaignUuid) {
      voohCampaign {
        ... on VoohCampaign {
          ...VoohCampaignFields
        }
      }
    }
  }
`
